import { ParticleOptions } from '../particles.types';

export const getOptions = (): ParticleOptions => ({
  autoPlay: true,
  fullScreen: {
    enable: true,
    zIndex: 100,
  },
  emitters: [],
  particles: {
    number: {
      value: 0,
    },
  },
});
